export default __webpack_public_path__ + "locales/bg/PeopleTranslations.json?hash=d2fd2b18c566224da10e114295b38e13";